import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const WalletRequest = async(params = {}) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('token');

    const cleanParams = Object.entries(params || {}).reduce((acc, [key, value]) => {
      if (value === undefined || value === null || value === "") return acc;
      acc[key] = value;
      return acc;
    }, {});

    const hasAdminEmail = Boolean(cleanParams.email);
    const endpoint = hasAdminEmail ? "/admin/wallet" : "/wallet";

    const res = await AxiosInstance.get(endpoint, {
      ...(Object.keys(cleanParams).length > 0 ? { params: cleanParams } : {}),
      headers: {
        'Authorization': `Bearer ${token}`
        }
    });

    return res;
  } catch (error) {
    console.error('error in request:', error);
    throw error;
  }     
};

export default WalletRequest;
